import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface MeetingAddDialogData {
  typeOnlyKeys?: string[];
}

@Component({
  selector: 'app-meeting-add-dialog',
  templateUrl: './meeting-add-dialog.component.html',
  styleUrls: ['./meeting-add-dialog.component.scss']
})
export class MeetingAddDialogComponent implements OnInit {
  typeOnlyKeys?: string[];

  constructor(
    public dialogRef: MatDialogRef<MeetingAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MeetingAddDialogData
  ) {
    this.typeOnlyKeys = data.typeOnlyKeys;
  }

  ngOnInit(): void {}

  closeDialog(e): void {
    this.dialogRef.close(e);
  }
}
